/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { observer } from 'mobx-react'
import * as dayjs from 'dayjs'
import { Table, Icon } from 'antd'
// import { userAction } from '../../../action/user'
import { userCertStore } from '../../../store/list/UserCertModel'
import { GeneralStyles } from '../../../styles/general'

import BusinessStatus from '../../../business/status'
import StatusTag from '../../../components/StatusTag'
import UserViewer from '../../../components/business/UserViewer'

import UserAuditAction from './UserAuditAction'

interface IUserAuditListProps {}

interface IUserAuditListState {
  pageList: any[]

  loading: boolean

  pagination: {
    current: number
    total: number
    size: number
  }
}

const USER_AUTH_STATE = BusinessStatus.user_cert

interface UserAuditList {
  props: IUserAuditListProps
  state: IUserAuditListState
}

const pageColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    render: (text: any) => <UserViewer uid={text}/>,
  },
  {
    title: '姓名',
    dataIndex: 'realname',
    key: 'realname',
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone',
  },
  {
    title: '组织',
    dataIndex: 'organization',
    key: 'organization',
  },
  {
    title: '职业',
    dataIndex: 'profession',
    key: 'profession',
  },
  {
    title: '提交时间',
    dataIndex: 'submit_time',
    key: 'submit_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '认证时间',
    dataIndex: 'auth_time',
    key: 'auth_time',
    render: (text: any) => (
      <span>{dayjs(text).format('YYYY年MM月DD日 HH:mm:ss')}</span>
    ),
  },
  {
    title: '状态',
    key: 'auth_status',
    dataIndex: 'auth_status',
    render: (status: any, item: any) => {
      return (
        <span>
          <StatusTag item={item} status={status} config={USER_AUTH_STATE}/>
        </span>
      )
    },
  },
  {
    title: '操作',
    key: 'action',
    render: (text: any, record: any) => {
      return <UserAuditAction text={text} record={record}/>
    },
  },
]

@observer
class UserAuditList extends Component {
  componentDidMount() {
    userCertStore.loadPageList()
  }

  handleTableChange = (pagination: any) => {
    if (pagination['current'] === userCertStore.listResponse.current) {
      return
    }

    userCertStore.changePage(pagination['current'])
  }

  render() {
    const listResponse = userCertStore.listResponse
    const pageList = listResponse.list.map((item: any) => {
      return {
        key: item['machine_id'],
        ...item,
      }
    })
    const loadState = userCertStore.listError

    return (
      <div className="general-page" css={GeneralStyles['general-page']}>
        <div css={GeneralStyles['page-head']}>
          <div className="head-title">
            <span className="title-text"><Icon type="audit" /> 用户认证请求列表</span>
          </div>
        </div>
        <div css={GeneralStyles['page-content']}>
          <div css={GeneralStyles['content-pane']}>
            <Table
              columns={pageColumns}
              rowKey={(record: any) => record.id}
              dataSource={pageList}
              pagination={{
                current: listResponse.current,
                total: listResponse.total,
                pageSize: listResponse.size,
              }}
              loading={loadState.state === 'loading'}
              onChange={this.handleTableChange}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default UserAuditList
